module.exports = __webpack_public_path__ + "static/media/info-icon.0922c869.svg";